import styles from '@components/pages/Product/components/ProductDropdown/ProductDropdown.module.scss';
import React, { useState } from 'react';
import { FontAwesomeProIcon, List, ListItem } from '@wienenergiegithub/ui-next';
import {
  Select,
  SelectArrow,
  SelectItem,
  SelectLabel,
  SelectPopover,
  SelectProvider,
} from '@ariakit/react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';

const ProductDropdown = ({
  items,
  onSelect,
  selectedItem,
  label,
  name,
  className,
  dataPurpose,
}) => {
  const initialValue = items?.find(item => item.value === selectedItem);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(initialValue?.label);

  const handleSetValue = newValue => {
    onSelect(newValue);
    setValue(newValue);
  };

  return (
    <div className={classNames(styles.container, className)}>
      <List
        icon={<FontAwesomeProIcon icon="check" type="regular" />}
        noSpacing
        type="checkmark"
      >
        <ListItem className={styles.listItem}>
          {items?.length > 1 ? (
            <SelectProvider
              animated
              open={open}
              setOpen={setOpen}
              setValue={handleSetValue}
              value={value}
            >
              <div className={styles.listItemContent}>
                <SelectLabel
                  className={styles.label}
                  data-purpose={dataPurpose}
                  onClick={() => {
                    if (!open) {
                      setOpen(true);
                    }
                  }}
                >
                  {label}
                </SelectLabel>
                <Select className={styles.select} name={name}>
                  {items.filter(item => item.value === selectedItem)[0]?.label}
                  <SelectArrow
                    render={
                      <FontAwesomeProIcon
                        as="span"
                        className={styles.chevron}
                        icon={open ? 'chevron-up' : 'chevron-down'}
                        role="presentation"
                      />
                    }
                  />
                </Select>
                <SelectPopover className={styles.popover} gutter={2}>
                  {items.map(item => (
                    <SelectItem
                      className={styles.item}
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </SelectItem>
                  ))}
                </SelectPopover>
              </div>
            </SelectProvider>
          ) : (
            <div className={styles.listItemContent}>
              <span className={styles.singleLabel}>{label}</span>
              {items[0]?.label && (
                <p className={styles.singlePill}>{items[0].label}</p>
              )}
            </div>
          )}
        </ListItem>
      </List>
    </div>
  );
};

ProductDropdown.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  selectedItem: PropTypes.string,
};

ProductDropdown.defaultProps = {
  className: '',
  onSelect: () => {},
  selectedItem: null,
};

export default ProductDropdown;
